import styled from 'styled-components';

import { mediaQuery } from '../../../../../styles/global';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 20px 100px;
  align-items: center;
  ${mediaQuery.maxWidth.phone} {
    padding: 0 20px 50px;
  }
`;

export const ViewSwitcher = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 20px 40px;
`;

export const ContentBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-top: 40px;
`;

export const Caption = styled.h3`
  font-size: 2.8rem;
  margin: 0;
  font-family: ${({ theme }) => theme.fontFamily.bold};
  color: ${({ theme }) => theme.colors.white};
  ${mediaQuery.maxWidth.phone} {
    font-size: 1.5rem;
  }
`;

export const SubCaption = styled.p`
  letter-spacing: 0.2em;
  font-size: 10px;
  text-transform: uppercase;
`;

export const Description = styled.div`
  line-height: 170%;
`;
